


export const questions = [
  {
    id: 1,
    title: "¿Qué tipo de software desarrollan?",
    answer: "Ofrecemos desarrollo a medida, aplicaciones móviles, sistemas empresariales, plataformas web y soluciones de inteligencia artificial.",
  },
  {
    id: 2,
    title: "¿Brindan soporte después del desarrollo?",
    answer:
      "Sí, ofrecemos mantenimiento y actualizaciones para garantizar el buen funcionamiento del software.",
  },
  {
    id: 3,
    title: "¿Cómo funciona el proceso de desarrollo de software?",
    answer:
      "Trabajamos bajo metodologías ágiles: análisis de necesidades, diseño, desarrollo, pruebas y entrega.",
  },
  {
    id: 4,
    title: "¿Instalán fibra óptica?",
    answer:
      "Sí, instalamos fibra óptica para ofrecer conexiones de alta velocidad y confiabilidad.",
  },
];




